module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.109/js/sprocket_orange.svg"